export default __webpack_public_path__ + "static/media/Cours.4bb56163.svg";